/**
 * Domain types shared by the API and the web application.
 *
 * All timestamps are ISO 8601 strings on the wire and epoch milliseconds
 * inside sort keys. All money is integer cents in whole dollars.
 */
export const FEEDBACK_KINDS = ['bug', 'message'];
export const FEEDBACK_LIMITS = {
    messageMinLength: 10,
    messageMaxLength: 2000,
    /** Submissions accepted from one address in one clock hour. */
    perHourPerIp: 5,
};
// ---------------------------------------------------------------------------
// Job-description import
// ---------------------------------------------------------------------------
/**
 * How many parses an account may run in one UTC day: five for every listing it
 * has paid for, including a reservation whose details are still to come. The
 * flow pays first, so a company reaching this route always holds at least one
 * paid listing and the allowance is never zero mid-flow.
 */
export const PARSE_DAILY_PER_PAID_LISTING = 5;
/**
 * The ceiling no account clears, however many listings it holds. The parse
 * spends money with a third party on every call; an account with two hundred
 * listings would otherwise be handed a thousand-call-a-day key to that bill.
 */
export const PARSE_DAILY_ABSOLUTE_CAP = 50;
/** Longest job-posting address this service will even look at. */
export const PARSE_URL_MAX_LENGTH = 2048;
//# sourceMappingURL=types.js.map